import { createSelector } from '@reduxjs/toolkit';
import { fetchCityStateSuggestion } from '@/redux/api/cityStateSuggestion';
import { getAuthToken } from './user';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';

const LOAD_CITY_STATE_FAIL = 'la/ui/loadcitystate/FAIL';
export const LOAD_CITY_STATE_REQUEST = 'la/ui/loadcitystate/REQUEST';
export const LOAD_CITY_STATE_SUCCESS = 'la/ui/loadcitystate/SUCCESS';

export type CityStateSuggestionState = {
    data: {
        city: string;
        state: string;
        zip: string;
    };
    submitted: boolean;
    success: boolean;
};

export const DEFAULT_STATE: CityStateSuggestionState = {
    data: { city: '', state: '', zip: '' },
    submitted: false,
    success: false,
};

export default function reducer(state = DEFAULT_STATE, action: any = {}): CityStateSuggestionState {
    switch (action.type) {
        case LOAD_CITY_STATE_FAIL:
            return {
                ...state,
                submitted: false,
                success: false,
            };
        case LOAD_CITY_STATE_REQUEST:
            return {
                ...state,
                submitted: true,
                success: false,
            };
        case LOAD_CITY_STATE_SUCCESS:
            return {
                ...state,
                data: { city: action.payload[0].city, state: action.payload[0].state, zip: action.payload[0].zip },
                submitted: false,
                success: true,
            };
        default:
            return state;
    }
}

const stateSelector = (state: GlobalState) => state.cityStateSuggestion;

export const getCityStateSuggestion = createSelector(stateSelector, (state) => state);

export const loadCityAndStateByZip = (zipcode: string) => async (dispatch: Function, getState: Function) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        dispatch({
            type: LOAD_CITY_STATE_REQUEST,
        });
        const response = await fetchCityStateSuggestion({ authToken, deployment, zipcode });

        dispatch({
            payload: response.data,
            type: LOAD_CITY_STATE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            payload: error,
            type: LOAD_CITY_STATE_FAIL,
        });
    }
};
